export default () => ({
  component: 'payment-method-filter',
  componentAttrs: {
    clearable: true,
    'persistent-border': true,
  },
});
